import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {EventsService} from "app/lib/EventsService";
import {BaseComponent} from "app/views/base.component";
import {HelperService} from "../../lib/helper.service";
import {FilterParams} from "../../models/filter_form.model";
import {HttpClient} from "@angular/common/http";
import {ChartParams} from "../../views/chart/chart.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {getTimeAsIntervals} from "../../lib/lib";
import * as qs from 'qs';
import {TemplateBillingDetailsComponent} from "./details/template_billing_details.component";
import { BillingService2 } from "../billing.service";

@Component({
	selector: 'template_billing',
	templateUrl: './template_billing.component.html'
})
export class TemplateBillingComponent extends BaseComponent {
	chart = new ChartParams();

	info: any;

	addFilterParams = {
		userType: 'user',
		isBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
		dateType: 'datePaid'
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);

		this.filter.addFilters.push('promocode');

		this.chart.setOptions({
			title: '',
			names: {
				'paidCount': this.translate.__A('common.paidCount')
			},
			colors: {
				'paidCount': '#1f77b4'
			},
			showLabels: [
				'paidCount'
			]
		});
	}

	async getData() {
		await this.getTotal();
		await this.getChart();
		await this.getPagination();
	}

	async getTotal() {
		if (this.dontLoad.total) {
			return true;
		}

		this.info = null;

		this.chart.showLoader();
		this.info = await this.service2.templateBilling.total(
			this.filter.filterParams
		).toPromise();
		this.chart.hideLoader();
	}

	async getChart(params?: FilterParams) {
		if (this.dontLoad.chart) {
			return true;
		}

		this.chart.showLoader();
		const { charts } = await this.service2.templateBilling.chart(
			this.filter.getCopyFilterParams(params)
		).toPromise();
		this.chart.data = charts;
		this.chart.hideLoader();
	}

	async getPagination() {
		const me = this;

		if (me.filter.filterParams.period == 'summary') {
			await me.getStats();
			return true;
		}

		me.paginationLoader = true;

		const pagination = await me.service2.templateBilling.pagination(
			me.filter.filterParams
		).toPromise();
		me.pagination.fill(pagination);

		if (pagination) {
			me.updateLinks(
				me.service2.templateBilling.getRealFullRoute()
			)
		}

		me.paginationLoader = false;
		
		await me.getStats();		
	}

	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;

		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});

		this.dontLoad = {
			total: true,
			chart: true,
			pagination: true
		};
	}

	async getStats() {
		let me = this;

		me.paginationLoader = true;

		const { stats } = await me.service2.templateBilling.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;

		for (let stat of me.stats) {
			let dates = getTimeAsIntervals({
				timestamp: stat.timestamp,
				period: me.filter.filterParams.period
			});

			if (dates.length === 2) {
				stat.currentPeriod = dates[0] + '-' + dates[1];
			} else {
				stat.currentPeriod = dates[0];
			}

			stat.day = new Date(stat.timestamp).getDay();

			if (stat.currentPeriod == '') stat.currentPeriod = 'summary';
		}

		me.paginationLoader = false;
		me.dontLoad = {};
	}

	async showDetails(timestamp: number, period: string) {
		const modalRef = this.modalService.open(TemplateBillingDetailsComponent, {
			title: period,
		}, {size: 'hg'});

		const { stats } = await this.service2.templateBilling.detail(
			this.filter.getCopyFilterParams(<FilterParams>{ timestamp })
		).toPromise();

		modalRef.componentInstance.details = stats;
	}
}
